import { render, staticRenderFns } from "./wamadmin.vue?vue&type=template&id=ef138d32"
import script from "./wamadmin.vue?vue&type=script&lang=js"
export * from "./wamadmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports